import { render, staticRenderFns } from "./InfoRow.vue?vue&type=template&id=2d2de118&scoped=true&"
import script from "./InfoRow.vue?vue&type=script&lang=tsx&"
export * from "./InfoRow.vue?vue&type=script&lang=tsx&"
import style0 from "./InfoRow.vue?vue&type=style&index=0&id=2d2de118&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2de118",
  null
  
)

export default component.exports